import React from 'react';
import PropTypes from 'prop-types';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ModalComponent from 'molecules/Modal';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

export const ReedemConfirmationModal = props => {
  const { showConfirmationModal, handleRedeemBtn } = props;
  const { CONFIRM_REDEEM, CANCEL_REDEEM, REDEEM_CONFIRMATION_MESSAGE } = TRANSLATE_MAPPING_KEY;
  const modalProps = {
    id: 'redeemConfirmationModal',
    show: true,
    role: 'dialog',
    modalTitleId: 'redeemConfirmationModal',
    classNames: 'redeem-confirmation-modal white-background',
    showCloseBtn: false,
    autoFocus: true,
  };

  return (
    <>
      <ModalComponent {...modalProps} data-testid='offers-deals-modal-testid'>
        <div className='redeem-confirmation-wrapper'>
          <p className='redeem-confirmation-message'>{translateWithI18Next(REDEEM_CONFIRMATION_MESSAGE)}</p>
          <ContainedButton
            data-testid='redeem-confirmationId'
            onClickHandler={() => {
              handleRedeemBtn();
            }}
            className='redeem-confirmation'
            variant={ButtonType.secondary}
          >
            {translateWithI18Next(CONFIRM_REDEEM)}
          </ContainedButton>
          <ContainedButton
            data-testid='redeem-cancelId'
            onClickHandler={() => {
              showConfirmationModal(false);
            }}
            className='redeem-cancel'
            variant={ButtonType.secondary}
          >
            {translateWithI18Next(CANCEL_REDEEM)}
          </ContainedButton>
        </div>
      </ModalComponent>
    </>
  );
};
ReedemConfirmationModal.propTypes = {
  showConfirmationModal: PropTypes.func,
  handleRedeemBtn: PropTypes.func,
};
ReedemConfirmationModal.defaultProps = {
  showConfirmationModal: null,
  handleRedeemBtn: null,
};

export default ReedemConfirmationModal;
